import { Popover, PopoverContent, PopoverTrigger } from "../../ui/popover";
import { Calendar as CalendarIcon } from "lucide-react";
import Calendar from "../../ui/calendar";
import { cn } from "../../../shared/utils";
import { ro } from "date-fns/locale";
import PropTypes from "prop-types";
import { format } from "date-fns";

export function DatePickerInput({
    name,
    label,
    value,
    handleChange,
    customStyles,
    dateFormat = "yyyy-MM-dd",
    disabled,
    outputAsIso = false,
    endOfDay = false,
}) {
    const handleDateSelect = (date) => {
        if (!date) {
            handleChange({ target: { name, value: "" } });
            return;
        }

        let outputValue;

        if (outputAsIso) {
            // Output ISO 8601 string format
            const selectedDate = new Date(date);

            if (endOfDay) {
                // Set to end of day (23:59:59) in local timezone
                selectedDate.setHours(23, 59, 59, 0);
            }

            // Convert to ISO string (UTC)
            outputValue = selectedDate.toISOString();

            // DEBUG: Log what we're outputting
            console.log('📅 DatePickerInput Output (ISO mode):');
            console.log('  - selected date:', date);
            console.log('  - endOfDay:', endOfDay);
            console.log('  - output value:', outputValue);
        } else {
            // Default: output formatted string (YYYY-MM-DD)
            outputValue = format(new Date(date), dateFormat);

            // DEBUG: Log what we're outputting
            console.log('📅 DatePickerInput Output (default mode):');
            console.log('  - selected date:', date);
            console.log('  - dateFormat:', dateFormat);
            console.log('  - output value:', outputValue);
        }

        handleChange({ target: { name, value: outputValue } });
    };

    return (
        <Popover>
            <PopoverTrigger asChild disabled={disabled} className={"disabled:cursor-not-allowed disabled:opacity-50"}>
                <button
                    className={cn(
                        "flex min-h-[36.8px] w-full flex-col justify-center rounded-md text-left text-dark hover:bg-white hover:text-dark focus:bg-white",
                    )}>
                    <label htmlFor={name} className={cn(customStyles, "w-full text-center font-bold text-dark")}>
                        {label}
                    </label>
                    <div className={"flex w-full items-center justify-center text-[16px]"}>
                        <CalendarIcon className="mr-2 h-4 w-4" />
                        {value ? (
                            format(new Date(value), "PPP", { locale: ro })
                        ) : (
                            <span className={"font-bold text-dark"}>{label}</span>
                        )}
                    </div>
                </button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0">
                <Calendar
                    mode="single"
                    selected={value ? new Date(value) : undefined}
                    initialFocus
                    locale={ro}
                    onSelect={handleDateSelect}
                />
            </PopoverContent>
        </Popover>
    );
}

DatePickerInput.propTypes = {
    disabled: PropTypes.bool,
    dateFormat: PropTypes.string,
    customStyles: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
    outputAsIso: PropTypes.bool,
    endOfDay: PropTypes.bool,
};
